/**
 * Created by Christiaan on 01/03/2017.
 */
import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    ViewChild
} from '@angular/core';
import {GlobalAlertService} from '../../global-alert.service';
import {GlobalPopup} from '../../global-popup';
import {HTTPError} from '../../../../shared/services/http/http-error';
import {RequestFailure} from '../../../../shared/services/http/request-failure';
import {FormDataService} from '../../../../shared/components/form/services/form-data.service';
import {FormComponent} from '../../../../shared/components/form/containers/form/form.component';
import {TranslateService} from '../../../../shared/services/translate/translate.service';
import {AbstractBasePopupComponent} from '../abstract-base-popup.component';
import {TooltipService} from '../../../../shared/services/tooltip/tooltip.service';
import {FormEvent} from '../../../../shared/components/form/containers/form/form.interface';
import {GlobalModel} from '../../../../shared/services/state/global.model';
import {LoggerService} from "../../../../shared/services/logger/logger.service";
import {
    ProjectActivitiesConfigActivity
} from "../../../../shared/components/check-activities/check-activities.interface";

@Component({
    selector: 'global-popup-create-check-activity-component',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './global-popup-create-check-activity.component.html',
})

export class GlobalPopupCreateCheckActivityComponent extends AbstractBasePopupComponent implements AfterViewInit {
    @Input() requestUrl: string = '';
    @Input() submitUrl: string = '';
    @Input() baseObjectId: number = -1;
    @Input() batchUpdate: boolean = false;

    @ViewChild('form', {static: false}) form: any;
    @ViewChild('activityDropDown', {static: false}) activityDropDown: any;
    
    public activityDropDownData: any[];
    public isEmptyForm: boolean = false;
    
    public constructor(
        protected cd: ChangeDetectorRef,
        protected globalAlertService: GlobalAlertService,
        protected formDataService: FormDataService,
        protected elementRef: ElementRef,
        protected ts: TranslateService,
        protected tooltipService: TooltipService,
        protected model: GlobalModel,
        protected logger:LoggerService
    ) {
        super(cd, globalAlertService, elementRef, ts, tooltipService, logger);
    }
    
    ngAfterViewInit() {
        // Retrieve map item id from the popup data
        this.requestUrl = this.globalPopup.data.requestUrl;
        this.submitUrl = this.globalPopup.data.submitUrl;
        this.baseObjectId = this.globalPopup.data.baseObjectId;
        this.batchUpdate = this.globalPopup.data.batchUpdate;

        // Update activity dropdowndata, and trigger view refresh
        this.activityDropDownData = this.globalPopup.data.activityDropDownData;
        this.submitButton = this.getSubmitButton();
        this.cd.detectChanges();
        
        setTimeout(() => {
            this.requestFormData();
        });
    }
    
    handlePopupAction(event: MouseEvent, alert: GlobalPopup, button: any): void {
        // callback for submit button comes from this form, not from outside this component
        if (button === this.submitButton) {
            this.form.handleComponentEvent({event: FormEvent.SAVE, data: {}});

            // this.form.submitForm();
        } else {
            // Hide alert and perform callback of button
            this.onPopupAction.emit({event: event, alert: alert, button: button});
        }
    }
    
    public requestFormData(): void {
        this.isLoading = true;
        
        let url: string = this.requestUrl + this.getActivityId() + '/' + this.baseObjectId;
        
        // Single edit mode
        if (!this.activityDropDown) {
            url = this.requestUrl;
        }
        
        this.formDataService.getFormData(url,
            (formData: any) => {
                this.formData = formData;
                this.checkIfEmptyForm(formData)
                this.isLoading = false;

                this.cd.detectChanges();
            },
            () => {
                this.closePopup(null);
            },
            () => {
                this.closePopup(null);
            }
        );
    }

    private checkIfEmptyForm(formData: any) {
        let isEmpty: boolean = false;
        if(formData && formData.schema?.children[0]?.children?.length == 0 && !this.activityDropDownData) {
            isEmpty = true;
        }
        this.isEmptyForm = isEmpty;
    }
    
    public handleComponentEvent(eventData: any): void {
        if (eventData.event === FormEvent.SAVE) {

            this.submitFormData(eventData.data.formData);
        }
    }
    
    private submitFormData(form: any): void {
        this.handleSubmitForm();

        let url: string = this.submitUrl + this.getActivityId() + '/' + this.baseObjectId;
        
        // Single edit mode
        if (!this.activityDropDown) {
            url = this.submitUrl;

        }
        if (this.batchUpdate) {
             url = this.submitUrl + 'batch/' + this.getActivityId();

            // let fullForm = {[formName]: form, baseObjectIds: itemIdString};
            this.formDataService.setBatchUpdateFormDataPopUp(this.formData, url, form,
                this.getFormName(), this.model.projectsManageSelectedItems.value,
                () => {
                    // this.doDefaultCloseHandling(null, false);
                    this.onPopupAction.emit({
                        event: null,
                        alert: this.globalPopup,
                        button: this.submitButton
                    });
                },
                (failure: RequestFailure) => {
                    this.handleSubmitResponse(failure.formErrors);
                },
                () => {
                    this.handleSubmitResponse(null, true);
                },
            );
        } else {
            this.formDataService.setFormData(form, this.getFormName(), url,
                (formData: any) => {
                    // this.formData = formData;
                    this.handleSubmitResponse();

                    // Hide alert and perform success callback via submit button
                    this.onPopupAction.emit({
                        event: null,
                        alert: this.globalPopup,
                        button: this.submitButton,
                        data: formData
                    });
                    //  data:{lat:form.location.latitude, lng:form.location.longitude}});
                },
                (failure: RequestFailure) => {
                    this.logger.log('[GlobalPopupCreateBaseObjectComponent] ' + 'Handle failure response: ', failure);
                    this.handleSubmitResponse(failure.formErrors);
                },
                (error: HTTPError) => {
                    this.handleSubmitResponse(null, true);
                }
            );
        }
    }
    
    public closePopup(event: any): void {
        this.doDefaultCloseHandling(event, true);
    }
    
    public handleChangeActivity(event: any): void {
        this.formData = null;
        this.requestFormData();
    }
    
    private getActivityId(): string {
        
        // Safety for element not loaded
        let activity: string = 'no_id';

        if (this.activityDropDown && this.activityDropDown.nativeElement) {
            activity = this.activityDropDown.nativeElement.value;
        }
        
        return activity;
    }
}
